import axios from "axios";
import store from "../store/index";
import axiosUrl from "./axios.service";
const API_URL = axiosUrl.getAxiosUrl();

class GlobalSettingsService {
  async getGlobalSettings() {
    return await axios
      .get(API_URL + `globalSettings/getSettings`)
      .then(response => {
        store.commit("globalSettings/setSettings", response.data);
      })
      .catch(error => {
        if (error) {
          store.commit("globalSettings/updateModalError", error.response.data),
            store.commit("globalSettings/enableModalError");
        }
      });
  }

  async updateGlobalSettings(settings) {
    return await axios
      .post(API_URL + `globalSettings/updateSettings`, {
        ...settings
      })
      .then(response => {
        if (response && response.status === 200) {
          store.commit(
            "infoModal/setInfoModalText",
            "Update has been completed."
          );
          store.commit("infoModal/openInfoModal");
        }
      })
      .catch(error => {
        if (error) {
          store.commit("globalSettings/updateModalError", error.response.data),
            store.commit("globalSettings/enableModalError");
        }
      });
  }
}

export default new GlobalSettingsService();
